const CHART_COLOR = "hsl(220, 80%, 60%)"

export const positionChartConfig = {
  position: {
    label: "Position",
    color: CHART_COLOR,
  },
}

export function formatDate(dateStr) {
  const [year, month, day] = dateStr.split("-")
  const date = new Date(year, month - 1, day)
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" })
}

export function dateLabelFormatter(value, payload) {
  if (payload?.[0]?.payload?.dateLabel) {
    return payload[0].payload.dateLabel
  }
  return value
}

export function ChartGradient({ id, colorVar = "var(--color-position)" }) {
  return (
    <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
      <stop offset="0%" stopColor={colorVar} stopOpacity={0.4} />
      <stop offset="50%" stopColor={colorVar} stopOpacity={0.15} />
      <stop offset="100%" stopColor={colorVar} stopOpacity={0.02} />
    </linearGradient>
  )
}

export function GlowFilter({ id }) {
  return (
    <filter id={id} x="-50%" y="-50%" width="200%" height="200%">
      <feGaussianBlur in="SourceGraphic" stdDeviation="3" result="blur" />
      <feColorMatrix in="blur" type="matrix"
        values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 0.4 0"
        result="glow" />
      <feMerge>
        <feMergeNode in="glow" />
        <feMergeNode in="SourceGraphic" />
      </feMerge>
    </filter>
  )
}

export function ChartDot({ cx, cy, payload, dataKey, colorVar = "var(--color-position)" }) {
  const value = dataKey ? payload[dataKey] : payload.position
  if (value == null) return null
  return (
    <g>
      <circle cx={cx} cy={cy} r={5} fill="white" stroke={colorVar} strokeWidth={2} />
      <circle cx={cx} cy={cy} r={2} fill={colorVar} />
    </g>
  )
}

export function ActiveDot({ cx, cy, colorVar = "var(--color-position)" }) {
  return (
    <g>
      <circle cx={cx} cy={cy} r={12} fill={colorVar} opacity={0.15} />
      <circle cx={cx} cy={cy} r={7} fill="white" stroke={colorVar} strokeWidth={2.5} />
      <circle cx={cx} cy={cy} r={3} fill={colorVar} />
    </g>
  )
}
